import React from "react";
import { Modal, styled } from "@mui/material";
import Lottie from "react-lottie";
import SuccessLottie from "../../assets/lotties/SUCCESS.json";
import SorryLottie from "../../assets/lotties/SORRY.json";


const StatusModalContainer = styled("div")(({theme}) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "fit-content",
  borderRadius: 10,
  outline: "none",
  width: "30vw",
  backgroundColor: "#fff",
  padding: 20,
  "& .status-text": {
    //   fontWeight:600,
    textAlign: "center",
  },
  [theme.breakpoints.down('md')]:{
    width:'45vw'
  },
  [theme.breakpoints.down('sm')]:{
    width:'60vw'
  },

}));

const StatusModal = ({ status, state, toggleModal }) => {
  const lottieOptions = {
    loop: !(status === "success"),
    autoplay: true,
    animationData: status === "success" ? SuccessLottie : SorryLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Modal open={state} onClose={toggleModal}>
      <StatusModalContainer>
        <Lottie options={lottieOptions} width={200} height={200} />
        <div className="status-text">
          {status === "success"
            ? " Your message was sent to me successfully! I will respond to you asap 😊."
            : "It seems there is some problem with the server. Please contect me through linkedin or any other of my social handles. "}
        </div>
      </StatusModalContainer>
    </Modal>
  );
};

export default StatusModal;
